import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

const t = {
  fr: {
    label: 'Notre Vision',
    h2a: 'We don\'t just manage',
    h2b: 'social media.',
    h2c: ' We create digital',
    h2d: 'experiences.',
    p1: ['<strong>Cocoonut Digital</strong> est un studio créatif basé à <strong>Strasbourg</strong>, spécialisé dans la narration visuelle pour les <strong>restaurants</strong>, hôtels, cafés et <strong>lieux de vie</strong>.'],
    p2: 'À travers la <strong>création de contenu</strong>, les stratégies Instagram et le <strong>storytelling culinaire</strong>, nous mettons en lumière les saveurs, les recettes et l\'expérience unique de chaque établissement.',
    p3: 'Notre approche mêle <strong>sensibilité multiculturelle</strong>, créativité et exigence du détail pour créer des présences digitales authentiques et mémorables.',
    menuLink: 'Voir le menu des offres',
    portfolioLink: 'Voir nos réalisations',
  },
  en: {
    label: 'Our Vision',
    h2a: 'We don\'t just manage',
    h2b: 'social media.',
    h2c: ' We create digital',
    h2d: 'experiences.',
    p1: ['<strong>Cocoonut Digital</strong> is a creative studio based in <strong>Strasbourg</strong>, specialising in visual storytelling for <strong>restaurants</strong>, hotels, cafés and <strong>hospitality venues</strong>.'],
    p2: 'Through <strong>content creation</strong>, Instagram strategies and <strong>culinary storytelling</strong>, we highlight the flavours, recipes and unique experience of each venue.',
    p3: 'Our approach blends <strong>multicultural sensitivity</strong>, creativity and attention to detail to create authentic and memorable digital presences.',
    menuLink: 'See our service menu',
    portfolioLink: 'See our work',
  },
};

const AboutSection = () => {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <section id="about" className="relative py-24 md:py-32 bg-[#f5f5f0]">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-8">
            <span className="text-sm uppercase tracking-widest text-[#717171] font-mono">{tx.label}</span>
          </motion.div>

          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }} className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#151515] mb-8 leading-tight">
            {tx.h2a}<br />{tx.h2b}
            <span className="text-[#4a5d6c]">{tx.h2c}<br />{tx.h2d}</span>
          </motion.h2>

          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.4 }} className="space-y-6 text-lg md:text-xl text-[#151515]/70 leading-relaxed" data-testid="about-description">
            <p dangerouslySetInnerHTML={{ __html: tx.p1[0].replace(/<strong>/g, '<strong class="text-[#151515]">') }} />
            <p dangerouslySetInnerHTML={{ __html: tx.p2.replace(/<strong>/g, '<strong class="text-[#151515]">') }} />
            <p dangerouslySetInnerHTML={{ __html: tx.p3.replace(/<strong>/g, '<strong class="text-[#151515]">') }} />
          </motion.div>

          <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.5 }} className="flex flex-wrap gap-4 mt-8">
            <Link to="/menu" className="inline-flex items-center gap-2 text-[#1a3a52] hover:text-[#d4a574] transition-colors font-medium">
              {tx.menuLink} <ArrowRight size={18} />
            </Link>
            <a href="#portfolio" className="inline-flex items-center gap-2 text-[#1a3a52] hover:text-[#d4a574] transition-colors font-medium">
              {tx.portfolioLink} <ArrowRight size={18} />
            </a>
          </motion.div>
        </div>
      </div>
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-5 pointer-events-none">
        <svg viewBox="0 0 200 200" className="w-full h-full"><circle cx="100" cy="100" r="80" fill="#4a5d6c" /></svg>
      </div>
    </section>
  );
};

export default AboutSection;
